import { createFileRoute, Outlet } from "@tanstack/react-router";

import { CliFooter } from "@/landing/components/CliFooter";
import { CliNav } from "@/landing/components/CliNav";
import gridThemeCss from "@/landing/styles/grid-theme.css?url";
import { stewardFontLinks } from "@/landing/styles/steward-fonts";
import stewardThemeCss from "@/landing/styles/steward-theme.css?url";

/**
 * Pathless layout for the docs, legal pages and /update, on the Grid design
 * system with the landing's nav and footer. steward-theme.css stays underneath
 * because the nav and footer still read its --cli-* tokens and --header-height,
 * exactly as on the _landing layout. Pathless, so /docs, /terms, ... keep their
 * public URLs.
 */
export const Route = createFileRoute("/_steward")({
  component: StewardLayout,
  head: () => ({
    links: [
      { rel: "stylesheet", href: stewardThemeCss },
      { rel: "stylesheet", href: gridThemeCss },
      ...stewardFontLinks,
    ],
  }),
});

function StewardLayout() {
  return (
    <div className="steward-theme grid-theme" style={{ minHeight: "100vh" }}>
      <div className="relative z-10">
        <CliNav />
        <main>
          <Outlet />
        </main>
        <CliFooter />
      </div>
    </div>
  );
}
